/**
 * UI/UX P2-1: keyboard focus of a destination control. A Za'atar olive
 * outline (DESIGN.md focus colour, about 6:1 on white; the soft tone in dark
 * mode) offset from the control, so "focused" never looks like the lime
 * "selected" border and ring.
 */
export const DESTINATION_FOCUS_RING =
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zaatar-deep dark:focus-visible:outline-zaatar-soft';

/** The same outline drawn inside a list row, so the scrolling list does not clip it. */
export const DESTINATION_FOCUS_RING_INSET =
  'focus-visible:outline-2 focus-visible:[outline-offset:-2px] focus-visible:outline-zaatar-deep dark:focus-visible:outline-zaatar-soft';
